import React from 'react';
import { Box } from '@mui/material';
import LineChart from '../../../HomePage/PerformanceReview/Charts/Revenue/Line';

interface ChartProps {
    data: number[];
    categories: string[];
    title: string;
    height: number;
}

export default function Line(props: ChartProps){
    return (
        <Box sx={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', flexGrow: 1 }}>
            <LineChart data={props.data} categories={props.categories} title={props.title} height={props.height} />
        </Box>
    )
}